import React, { useState, useEffect } from "react";
import { Box, Divider } from "@mui/material";
import sh from "bundles/common/utils/sh";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { TrendingUp, Building2, CalendarCheck } from "lucide-react";
import { useIntl } from "react-intl";



const StatsSection = () => {
  const authenticityToken = useSelector((state) => state.authenticity_token);
  const [companyCount, setCompanyCount] = useState(0);
  const [jobOfferYearCount, setJobOfferYearCount] = useState(0);
  const [jobInterviewYearCount, setJobInterviewYearCount] = useState(0);
  const intl = useIntl();
    
  const fetchDataCount = () => {
    sh.get("landing_candidate_data", { authenticity_token: authenticityToken })
      .then((res) => {
        setCompanyCount(res.data.companies_count);
        setJobOfferYearCount(res.data.job_offer_year_count);
        setJobInterviewYearCount(res.data.job_interview_year_count);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchDataCount();
  }, []);

  const stats = [
    { icon: TrendingUp, value: jobOfferYearCount, label: intl.formatMessage({ id: "stats_section.job_offers_year_count" }) },
    { icon: Building2, value: companyCount, label: intl.formatMessage({ id: "stats_section.companies_count" }) },
    { icon: CalendarCheck, value: jobInterviewYearCount, label: intl.formatMessage({ id: "stats_section.job_interviews_year_count" }) },
  ];

  return (
    <>
      <Box
        component="section"
        sx={{
          py: "2rem",
          px: { xs: "1rem", sm: "1.5rem", lg: "2rem" },
          bgcolor: "hsl(160 10% 96% / 0.4)",
        }}
      >
        <Box sx={{ maxWidth: "56rem", mx: "auto" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" },
              gap: "1.5rem",
            }}
          >
            {stats.map((stat, i) => (
              <Box
                key={stat.label}
                component={motion.div}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                sx={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
              >
                <Box
                  sx={{
                    width: "2.5rem",
                    height: "2.5rem",
                    borderRadius: "0.75rem",
                    bgcolor: "hsl(153 68% 25% / 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <stat.icon size={18} color="hsl(153 68% 25%)" />
                </Box>
                <Box>
                  <Box
                    component="span"
                    sx={{
                      display: "block",
                      fontSize: "1.25rem",
                      color: "hsl(178 93% 10%)",
                      lineHeight: 1,
                      fontFamily: "Segoe UI Black",
                    }}
                  >
                    {stat.value}
                  </Box>
                  <Box component="span" sx={{ fontSize: "0.8rem", color: "hsl(178 10% 45%)", fontFamily: "Segoe UI Regular" }}>
                    {stat.label}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box><Divider sx={{ borderColor: "hsl(160 10% 90%)" }} />
    </>
  );
};

export default StatsSection;